class ProductQuickViewButton extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('button');
        this.handleClick = this.handleClick.bind(this);
        
    }

    connectedCallback() {
        if (this.button) {
            this.button.addEventListener('click', this.handleClick);
        }
    }

    disconnectedCallback() {
        const _this = this;
        if (this.button) {
            this.button.removeEventListener('click', function (){

                _this.handleClick(productUrl, sectionId)
            });
        }
    }

    async handleClick() {
        const productUrl = this.button.dataset.productUrl;
        const sectionId = 'ajax-quick-view-popup';
        
        document.querySelector('#choose-option-popup')?.classList.add('open');
        setTimeout(function () {
            document.querySelector('#choose-option-popup')?.classList.add('animation')
        }, 200);
        lockScrollbar();
        document.querySelector('#choose-option-popup .popup-content ')?.classList.add('loading');
        document.querySelector('#choose-option-popup [data-quick-view-slider]').innerHTML = '';
        document.querySelector('#choose-option-popup [data-quick-view-info]').innerHTML = '';

        await this.getSectionHtml(productUrl, sectionId)
    }
    async getSectionHtml(product_url,section_id, variant_id){
        try {
            const url = new URL(product_url, window.location.origin);
            url.searchParams.set('section_id', section_id);
            if(variant_id){
                url.searchParams.set('variant', variant_id);
            }


            const response = await fetch(url);
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');

            this.updatePopup(html);
            this.reinitScripts();


        } catch (error) {
            console.error('Quick view fetch failed:', error);
        } finally {
            document.querySelector('#choose-option-popup .popup-content ')?.classList.remove('loading')
        }
    }
    updatePopup(html){
        const selectors = {
            popup: '#choose-option-popup',
            ajax: '.js-quick-view-popup',
            slider: '[data-quick-view-slider]',
            info: '[data-quick-view-info]'
        };
        

        const elements = {
            quickViewSlider: document.querySelector(`${selectors.popup} ${selectors.slider}`),
            ajaxSlider: html.querySelector(`${selectors.ajax} ${selectors.slider}`),
            quickViewInfo: document.querySelector(`${selectors.popup} ${selectors.info}`),
            ajaxInfo: html.querySelector(`${selectors.ajax} ${selectors.info}`)
        };

        if (!elements.quickViewSlider || !elements.ajaxSlider ||
            !elements.quickViewInfo || !elements.ajaxInfo) return;

        elements.quickViewSlider.innerHTML = elements.ajaxSlider.innerHTML;
        elements.quickViewInfo.innerHTML = elements.ajaxInfo.innerHTML;

    }
    reinitScripts(){
        var sliderChoosePopup = document.querySelector('.choose-option-popup-main-slider');
        if (sliderChoosePopup) {
            var sliderThumb = document.querySelector('.choose-option-popup-thumbs');
            var counter = document.querySelector('.choose-option-popup-counter');
            var thumb = new Swiper(sliderThumb, {
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 8,
                speed: 200,
                direction: 'vertical',
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                preventClicks: false,
                preventClicksPropagation: false
            });
            var chooseSlider = new Swiper(sliderChoosePopup, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 200,
                navigation: {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
                thumbs: {swiper: thumb},
                breakpoints: {0: {slidesPerView: 1, spaceBetween: 4.5}, 1024: {slidesPerView: 1, spaceBetween: 0}},
                on: {
                    init: function init() {
                        updateQuickViewSliderCounter(this, counter)
                    }, slideChange: function slideChange() {
                        updateQuickViewSliderCounter(this, counter);
                        var activeIndex = this.realIndex;
                        var thumbsWrapper = thumb.wrapperEl;
                        var thumbsSlides = thumb.slides;
                        var activeSlide = thumbsSlides[activeIndex];
                        if (activeSlide && thumbsWrapper) {
                            var containerHeight = thumb.el.clientHeight;
                            var slideTop = activeSlide.offsetTop;
                            var slideHeight = activeSlide.offsetHeight;
                            var currentTranslate = thumb.getTranslate();
                            var targetTranslate = -slideTop;
                            if (slideTop + slideHeight > -currentTranslate + containerHeight) {
                                targetTranslate = -(slideTop - containerHeight + slideHeight)
                            }
                            var maxTranslate = 0;
                            var minTranslate = -(thumbsWrapper.scrollHeight - containerHeight);
                            if (targetTranslate > maxTranslate) targetTranslate = maxTranslate;
                            if (targetTranslate < minTranslate) targetTranslate = minTranslate;
                            thumb.setTranslate(targetTranslate);
                            thumb.updateActiveIndex(activeIndex)
                        }
                    }
                }
            });
            var thumbSlides = document.querySelectorAll('.choose-option-popup-thumbs .swiper-slide');
            thumbSlides.forEach(function (slide, index) {
                slide.addEventListener('click', function () {
                    chooseSlider.slideTo(index)
                })
            })
            const slideIndex = Array.from(sliderChoosePopup.querySelectorAll('.swiper-slide'))
                .findIndex(slide => slide.hasAttribute('data-initial'));
            if (slideIndex !== -1) {
                chooseSlider.slideTo(slideIndex);
            }
        }

        var quantityInput = document.querySelectorAll('#choose-option-popup .quantity');
        if (quantityInput.length) {
            quantityInput.forEach(function (quantity) {
                var plus = quantity.querySelector('.quantity-button--plus');
                var minus = quantity.querySelector('.quantity-button--minus');
                var input = quantity.querySelector('.quantity-input');
                if (plus) {
                    plus.addEventListener('click', function () {
                        var value = Number(input.value);
                        value++;
                        input.value = value;
                        if (value > 1) {
                            minus.classList.remove('_disabled')
                        }
                    })
                }
                if (minus) {
                    minus.addEventListener('click', function () {
                        var value = Number(input.value);
                        if (value > 1) {
                            value--;
                            input.value = value;
                            if (value == 1) {
                                minus.classList.add('_disabled')
                            }
                        }
                    })
                }
            })
        }
    }
}

if (!customElements.get('product-quick-view-button')) {
    customElements.define('product-quick-view-button', ProductQuickViewButton);
} 


class QuickVariantChange extends HTMLElement {
    constructor() {
        super();
        this.radioButtons = this.querySelectorAll('input[type="radio"]');
        this.bindEvents();
    }

    bindEvents() {
        if (!this.radioButtons?.length) return;
        this.radioButtons.forEach(input => {
            input.addEventListener('change', () => this.handleVariantChange());
        });
    }

    async handleVariantChange() {
        try {

            this.getSelectedOptions();
            this.getVariantId();
            this.updateQuickViewPopup();

        } catch (error) {
            console.error('Error handling variant change:', error);
        }
    }

    getSelectedOptions() {
        this.options = Array.from(this.querySelectorAll('fieldset'))
            .map(fieldset =>
                Array.from(fieldset.querySelectorAll('input'))
                    .find(radio => radio.checked)?.value
            )
            .filter(Boolean);
    }

    getVariantId() {
        const variantData = this.querySelector('[type="application/json"]')?.textContent;
        if (!variantData) return;

        const variants = JSON.parse(variantData);
        this.currentVariant = variants.find(variant =>
            variant.options.every((option, index) =>
                this.options[index] === option
            )
        );
    }

    updateQuickViewPopup(){
        const quickViewButtonObj = document.querySelector('product-quick-view-button');
        const quickViewPopup = document.querySelector('#choose-option-popup .popup-content');
        if(quickViewButtonObj){
            console.log("testset")
            quickViewButtonObj.getSectionHtml(this.dataset.url, 'ajax-quick-view-popup', this.currentVariant.id)
            quickViewPopup?.classList.add('loading')
        }
    }

}

customElements.define('quick-view-porudt-options', QuickVariantChange);



function updateQuickViewSliderCounter(swiper, counter) {
    var currentIndex = swiper.realIndex + 1;
    var totalSlides = swiper.slides.length;
    if (currentIndex === totalSlides) {
        counter.innerHTML = currentIndex + '/' + totalSlides
    } else {
        counter.innerHTML = currentIndex + '/' + totalSlides
    }
}